import { type CSSProperties, type ReactNode, useRef } from 'react';
import styled from 'styled-components';

import useTitlePreview from '@/hooks/pure/useTitlePreview';

import { Flex } from '../base';
import FadeDiv from '../Common/FadeDiv';
import Typo from '../Typography/Typo';

type Props = {
  title: string;
  textStyle?: CSSProperties;
  HoverItem?: ReactNode;
};

const FullTitlePreview = (props: Props) => {
  const ref = useRef<HTMLSpanElement>(null);

  const {
    isActiveEllipsis,
    displayFullTitlePos,
    handleMouseEnterEvent,
    handleMouseLeaveEvent,
    tooltipNode,
  } = useTitlePreview({
    ref: ref,
    text: props.title,
  });

  return (
    <Style
      onMouseEnter={handleMouseEnterEvent}
      onMouseLeave={handleMouseLeaveEvent}
      a="center"
    >
      <Typo style={{ ...props.textStyle }} ref={ref} multilineEllipsis={1}>
        {props.title}
      </Typo>
      {props.HoverItem && (
        <Flex className="title-hover-item">{props.HoverItem}</Flex>
      )}
      {isActiveEllipsis && displayFullTitlePos && tooltipNode}
    </Style>
  );
};

const Style = styled(Flex)`
  .title-hover-item {
    opacity: 0;
    transition: all 0.4s;
    position: absolute;
    top: 5px;
    right: 0px;
    transform: translateY(10px);
  }

  :hover {
    .title-hover-item {
      opacity: 1;
      transform: translateY(0px);
    }
  }
`;

const FullTitlePreviewStyle = styled(FadeDiv)`
  pointer-events: none;
  position: fixed;
  max-width: 400px;
  z-index: 10;
  background-color: ${(props) => props.theme.colors.FD60};
  backdrop-filter: blur(4px);
  color: ${(props) => props.theme.colors.FL80};
  padding: 8px 16px;
  border-radius: 5px;
  box-shadow: 2px 4px 24px ${(props) => props.theme.colors.FD16};
  word-break: break-all;
  font-size: 14px;
  line-height: 22px;
`;

export { FullTitlePreviewStyle };

export default FullTitlePreview;
